import DInlineFloat from "float-kit/components/d-inline-float";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
import templateOnly from "@ember/component/template-only";
const DHeadlessMenu = setComponentTemplate(createTemplateFactory(
/*
  
  <DInlineFloat
    @instance={{@menu}}
    @trapTab={{@menu.options.trapTab}}
    @mainClass="fk-d-menu"
    @innerClass="fk-d-menu__inner-content"
    @role="dialog"
    @inline={{@inline}}
  />

*/
{
  "id": "XEaTblOd",
  "block": "[[[1,\"\\n  \"],[8,[32,0],null,[[\"@instance\",\"@trapTab\",\"@mainClass\",\"@innerClass\",\"@role\",\"@inline\"],[[30,1],[30,1,[\"options\",\"trapTab\"]],\"fk-d-menu\",\"fk-d-menu__inner-content\",\"dialog\",[30,2]]],null],[1,\"\\n\"]],[\"@menu\",\"@inline\"],false,[]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/float-kit.d0433c99/node_modules/float-kit/components/d-headless-menu.js",
  "scope": () => [DInlineFloat],
  "isStrictMode": true
}), templateOnly());
export default DHeadlessMenu;